/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import MicrocredentialsIcon from 'icons/MicrocredentialIcon';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.microcredentials'},
});

const MicrocredentialsItem = () => (
  <RouteLinkItem
    iconBefore={MicrocredentialsIcon}
    route="midas/my/microcredentials"
    title={messages.title}
  />
);

export default MicrocredentialsItem;
